import { AppLayout, Box, Flashbar } from '@amzn/awsui-components-core';
import React from 'react';

import { LoadingSpinner } from 'src/components/generic-components/LoadingSpinner';
import { buildBreadcrumbChain } from 'src/utilities/RouteConfig';
import { useFinTechContext } from '../../context/FintechContextProvider';
import { HomePageSideNavigationV2 } from '../../side-navigation-v2/HomePageSideNavigationV2';
import { ErrorContainer } from '../FinTechOpsCommonElements';
import { FinTechOpsCostMetrics } from './FinTechOpsCostMetrics';
import { FinTechOpsDashboardHelpPanel } from './FinTechOpsDashBoardHelpPanel';
import { FinTechOpsDogma } from './FinTechOpsDogma';
import { FinTechOpsPolicyEngine } from './FinTechOpsPolicyEngine';
import { FinTechOpsSas } from './FinTechOpsSas';
import { FinTechOpsSelectionFilters } from './FinTechOpsSelectionFilters';
import { FinTechOpsTicket } from './FinTechOpsTicket';
import { FinTechOpsUseMetrics } from './FinTechOpsUserMetrics';

export const FinTechOpsPage: React.FC = () => {
  const finOpsContext = useFinTechContext();

  return (
    <AppLayout
      contentType="cards"
      tools={<FinTechOpsDashboardHelpPanel />}
      navigation={<HomePageSideNavigationV2 />}
      toolsHide={true}
      notifications={<Flashbar items={finOpsContext.flashbarItems} />}
      maxContentWidth={Number.MAX_VALUE}
      content={
        <Box margin={{ bottom: 'xxxl' }} padding={{ bottom: 'xxxl' }}>
          <FinTechOpsSelectionFilters />
          {finOpsContext.dashboardFilterDataCalculationStatus == 'loading' && <LoadingSpinner />}
          {finOpsContext.dashboardFilterDataCalculationStatus == 'error' && <ErrorContainer />}
          {finOpsContext.dashboardFilterDataCalculationStatus == 'finished' && (
            <>
              <FinTechOpsTicket />
              <FinTechOpsUseMetrics />
              <FinTechOpsSas />
              <FinTechOpsPolicyEngine />
              <FinTechOpsDogma />
              <FinTechOpsCostMetrics />
            </>
          )}
        </Box>
      }
    />
  );
};
